// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiLayersRemove } from "@mdi/js";
import { Popconfirm } from "antd";

import { ShapefileAction } from "../..";

interface IShapefileRemoveActionProps {
  isDisabled?: boolean;
  removeShapefile: () => void;
}

export function ShapefileFolderRemoveAction({
  isDisabled,
  removeShapefile
}: IShapefileRemoveActionProps) {
  return (
    <Popconfirm
      disabled={isDisabled}
      placement="bottom"
      onConfirm={(evt) => {
        removeShapefile();
        evt.stopPropagation();
        evt.preventDefault();
      }}
      onCancel={(evt) => {
        evt.stopPropagation();
        evt.preventDefault();
      }}
      okText="Delete"
      okType="danger"
      title={`Are you sure you want to remove the shapefile folder and its contents?`}>
      <ShapefileAction danger>
        <Icon path={mdiLayersRemove} size={"18px"} />
        Remove
      </ShapefileAction>
    </Popconfirm>
  );
}
